import { useAppSelector } from '@app/core/hooks/redux-hooks';
import {
  getForecastById,
  selectSortedCasesStructure,
} from '@app/core/store/project-slice-selectors';
import CurrencyLabel from '@app/shared/components/currency-label/CurrencyLabel';
import { numberValueFormatter, percentageValueFormatterProps } from '@app/shared/formatters';
import { Fragment } from 'react';
import styles from '@app/modules/projects/outputs/outputs-table.module.scss';
import TableSectionValuesPerForecast from '../components/TableSectionValuesPerForecast';
import CellValue from '@app/shared/components/cell-value/CellValue';
import {
  enteredPercentageViewRules,
  monthDayCellViewRules,
} from '@app/shared/components/cell-value/CellValueConfigurations';
import { CellValueTheme } from '@app/shared/components/cell-value/cell-value-theme';
import { useLocale } from '@app/core/hooks/useLocale';

export const Pwerm2WaterfallTableHeader = () => {
  const { l } = useLocale();
  const project = useAppSelector((state) => state.project.projectDraft);
  const casesStructure = useAppSelector(selectSortedCasesStructure);

  return (
    <thead className="table-primary__sticky-section" data-testid="waterfall-table-header">
      <tr data-testid="waterfall-table-header-row">
        <th className="table-primary__cell--vertical-separator" data-testid="currency-label-header">
          <CurrencyLabel />
        </th>
        {casesStructure.map((caseItem, index) => (
          <Fragment key={index}>
            <th
              className="table-primary__cell--vertical-separator"
              data-testid={`case-separator-${index}`}
            />
            <th
              colSpan={caseItem.forecasts.length}
              className="table-primary__cell--header-tertiary table-primary__cell--center table-primary__cell--vertical-separator"
              data-testid={`case-header-${index}`}>
              <span className={styles['case-name']} data-testid={`case-name-${index}`}>
                {caseItem.narrative} {' - '}
                {numberValueFormatter({
                  value: Number(caseItem.probability),
                  ...percentageValueFormatterProps,
                })}
              </span>
            </th>
          </Fragment>
        ))}
      </tr>
      <TableSectionValuesPerForecast
        title={l('_ExitDate')}
        renderAdditionalCell={() => (
          <CellValue
            value={project.valuationDate}
            {...monthDayCellViewRules}
            theme={CellValueTheme.Tertiary}
            dataTestId="exit-date-additional-cell"
          />
        )}
        renderCell={({ caseItem, forecast }) => (
          <CellValue
            value={getForecastById(project, caseItem.caseId, forecast.forecastId)?.forecastYear}
            {...monthDayCellViewRules}
            dataTestId={`exit-date-cell-${caseItem.caseId}-${forecast.forecastId}`}
          />
        )}
        renderSpacer={false}
      />
      <TableSectionValuesPerForecast
        title={l('_ExitProbability')}
        renderCell={({ caseItem, forecast }) => (
          <CellValue
            value={getForecastById(project, caseItem.caseId, forecast.forecastId)?.probability}
            {...enteredPercentageViewRules}
            dataTestId={`exit-probability-cell-${caseItem.caseId}-${forecast.forecastId}`}
          />
        )}
        renderSpacer={false}
      />
    </thead>
  );
};
